import { compose, map, values } from 'ramda';

import dataConnectionCollection from '../DataConnections/dataConnectionCollection';
import dataConnectionFactory from '../DataConnections/dataConnectionFactory';

// (DataConnection, { String: DataConnectionDefinition }) -> [DataConnection]
const makeDataConnections = (factory, definitions) =>
    compose(map(factory.makeDataConnection), values)(definitions);

function createDataConnections(
    template,
    api,
    shpAccess,
    xpathEngine,
    dataSources,
    settings,
) {
    const definitions = template.getDataConnectionDefinitions();
    const factory = dataConnectionFactory(
        api,
        shpAccess,
        template,
        xpathEngine,
        dataSources,
        settings,
    );
    const connections = makeDataConnections(factory, definitions);

    return dataConnectionCollection(connections);
}

export default createDataConnections;
